(() => {
  const theme = new URLSearchParams(window.location.search).get("theme");

  // No theme parameter → leave Dawn exactly as-is.
  if (!theme) return;

  const altKey = `cover-${theme}`.toLowerCase();

  document.querySelectorAll(".js-theme-image").forEach((container) => {
    const img = container.querySelector(".js-theme-main-image");
    if (!img) return;

    let images = {};

    try {
      images = JSON.parse(container.dataset.themeImages);
    } catch (e) {
      return;
    }

    // Find matching alt text (case-insensitive)
    const replacement = Object.keys(images).find(
      (key) => key.toLowerCase() === altKey
    );

    // Matching image not found → keep original image
    if (!replacement) return;

    img.src = images[replacement];

    // Remove responsive sources so browser uses the new image
    img.removeAttribute("srcset");
  });
})();